import { Home, Archive, Users, TrendingUp, Crown, User, Mail, Send, Inbox, FileText, MapPin, CheckSquare } from "lucide-react";

export const mainItems = [
  { title: "Startseite", url: "/", icon: Home },
  { title: "ToDos", url: "/todos", icon: CheckSquare },
  { title: "Laufliste", url: "/running-list", icon: MapPin },
  { title: "Kundenverwaltung", url: "/customers", icon: Users },
  { title: "Leistungserfassung", url: "/performance", icon: TrendingUp },
  { title: "Wissensbank", url: "/archive", icon: Archive },
];

export const emailItems = [
  { title: "E-Mail", url: "/email", icon: Mail },
  { title: "Eingang", url: "/email/inbox", icon: Inbox },
  { title: "Gesendet", url: "/email/sent", icon: Send },
  { title: "Entwürfe", url: "/email/drafts", icon: FileText },
];

export const otherItems = [
  { title: "Profil", url: "/profile", icon: User },
];
